export const SIRET_CHARACTERS_NUMBER = 14;
